export const SOCKET_TRANSPORTS = ['websocket', 'polling'];
export const VEHICLE_READY_REQUEST_EVENT = 'vehicleReadyRequest';

export const createVehicleReadySocket = ({ ioClient, baseURL }) =>
  ioClient(baseURL, {
    transports: SOCKET_TRANSPORTS,
  });

export const bindVehicleReadyRequestListener = (socket, handler) => {
  socket.on(VEHICLE_READY_REQUEST_EVENT, handler);

  return () => {
    if (typeof socket.off === 'function') {
      socket.off(VEHICLE_READY_REQUEST_EVENT, handler);
    }
  };
};
